module.exports = __webpack_public_path__ + "img/hrc-home.16bbd164.jpg";